import {
  Button,
  Classes,
  IconName,
  Intent,
  MaybeElement,
} from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";

import { useCommonHooks } from "../../hooks";
import { ICustomButtonProps } from "./ICustomButtonProps";

const StyledButton = styled(Button)<{ color: string }>`
  color: ${(props) => props.color} !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 0 !important;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    box-shadow: none !important;
  }

  &:focus {
    outline: none !important;
  }

  & .${Classes.ICON} {
    color: ${(props) => props.theme.primaryColor} !important;
  }
`;

export interface ILinkButtonProps
  extends Omit<ICustomButtonProps, "minimal" | "intent"> {
  icon?: IconName | MaybeElement;
  rightIcon?: IconName | MaybeElement;
  invertedColors?: boolean;
}

export const LinkButton: React.FunctionComponent<ILinkButtonProps> = ({
  onClick,
  loading,
  disabled,
  text,
  icon,
  rightIcon,
  invertedColors,
  className,
}) => {
  const { theme } = useCommonHooks();
  return (
    <StyledButton
      theme={theme}
      icon={icon}
      title={text}
      minimal={false}
      onClick={onClick}
      text={text}
      intent={Intent.NONE}
      loading={loading}
      disabled={disabled}
      rightIcon={rightIcon}
      color={invertedColors ? "white" : theme.primaryColor}
      className={className}
    />
  );
};
